/* RESPONSIBLE TEAM: team-omni */
import { default as StandaloneBaseWorkflowRoute } from 'embercom/routes/apps/app/standalone/channels/base-workflow';
import { inject as service } from '@ember/service';

export default class Route extends StandaloneBaseWorkflowRoute {
  @service declare permissionsService: $TSFixMe;

  setWorkflowOpenMode(controller: any, model: any) {
    let canEdit = this.permissionsService.currentAdminCan('can_manage_apps_and_integrations');
    if (!canEdit) {
      controller.set('mode', 'view');
      return;
    }
    super.setWorkflowOpenMode(controller, model);
  }
}
